import { UserContext } from '../UserContext';

export enum AppContextRequestReponseType {
    Valid = "Valid",
    NotSignedIn = 'NotSignedIn',
    NoSeats = "NoSeats"
}

export interface UserContextResponse {
    userContextData: UserContext;
    responseType: AppContextRequestReponseType;
}